import { Component, OnInit } from '@angular/core';

// ionic
import { PopoverController } from '@ionic/angular';

@Component({
    selector: 'app-suggest-keyword',
    templateUrl: './suggest-keyword.component.html',
    styleUrls: ['./suggest-keyword.component.scss'],
})
export class SuggestKeywordComponent implements OnInit {

    container;

    keyword: string;

    constructor(
        private popoverController: PopoverController
    ) { }

    ngOnInit() { }

    close() {
        this.popoverController.dismiss();
    }

    saveKeyword(valid) {
        if (valid) {
            //
            this.popoverController.dismiss({
                keyword: this.keyword,
                container: this.container
            });
        }
    }

}
